import {useRoute, useRouter} from "vue-router";
import {useUserStore} from "@/store/module/user";
import {computed, ref, watch} from "vue";
import {diff} from "ym-js-box";

export function useMenu() {
    const route = useRoute();
    const router = useRouter();
    const userStore = useUserStore();
    const selectedKey = ref(route.path);
    const openKeys = ref([]);

    const menus = computed(() => {
        return userStore.menuList;
    });
    watch(
        route,
        () => {
            selectedKey.value = route.path;
            const andParents = getParents(menus.value, route.path);
            if (andParents && andParents.length > 0) {
                let andParentKeys = andParents.map((item) => item.path);
                openKeys.value = [...andParentKeys];
            }
        },
        {immediate: true}
    );

    const to = (path) => {
        router.push(path);
    };

    function changeSelectedKey(path) {
        // let node = getNode(userStore.menuList, path);
        to(path);
    }

    function changeOpenKeys(keys) {
        const addArr = diff(openKeys.value, keys);
        if (keys.length > openKeys.value.length) {
            let arr = getParents(menus.value, addArr[0]);
            if (arr && arr.length > 0) {
                openKeys.value = arr.map((item) => {
                    return item.path;
                });
            }
        } else {
            openKeys.value = keys;
        }
    }

    return {
        selectedKey,
        openKeys,
        changeOpenKeys,
        changeSelectedKey,
        menus
    };
}

/** 获取当前节点
 *
 * @param list 集合
    * @param path 节点
    */
export function getNode(list, path){
    for (let i in list) {
        let item = list[i];
        if (item?.path === path) {
            return item;
        } else {
            if (item?.child) {
                let value = getNode(item.child, path);
                if (value) {
                    return value;
                }
            }
        }
    }
}

/**
 * 获取所有父节点 ( 包含当前节点 )
 *
 * @param list 集合
 * @param path 节点
 */
export function getParents(list, path){
    for (let i in list) {
        if (list[i]?.path === path) {
            return [list[i]]
        }
        if (list[i]?.child.length > 0) {
            let node = getParents(list[i].child, path)
            if (node !== undefined) {
                return node.concat(list[i])
            }
        }
    }
}
